export default __webpack_public_path__ + "static/media/code-template.d2a1339d.csv";